"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuTrigger = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const IconButton_1 = require("../desktop/IconButton");
const MenuTrigger_module_css_1 = __importDefault(require("./MenuTrigger.module.css"));
const web_core_ui_1 = require("@snapchat/web-core-ui");
/**
 * Hamburger menu trigger to toggle the mobile menu
 */
function MenuTrigger({ onMenuClick, useMinifiedLayout, }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { "aria-label": intl.formatMessage({
            id: "pr9aMR",
            defaultMessage: "Open Mobile Navigation",
            description: "Open Mobile Navigation Aria Label",
        }), "data-testid": "mobile-menu-trigger", onClick: onMenuClick, className: useMinifiedLayout ? MenuTrigger_module_css_1.default.transparentMenuButton : undefined, children: useMinifiedLayout ? ((0, jsx_runtime_1.jsx)("span", { className: MenuTrigger_module_css_1.default.miniMoreOptionsIcon, "data-testid": "mobile-menu-mini-trigger", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.MoreOptionsIcon, { size: "LARGE" }) })) : ((0, jsx_runtime_1.jsxs)("span", { className: MenuTrigger_module_css_1.default.hamburger, children: [(0, jsx_runtime_1.jsx)("span", { className: MenuTrigger_module_css_1.default.bun }), (0, jsx_runtime_1.jsx)("span", { className: MenuTrigger_module_css_1.default.burger }), (0, jsx_runtime_1.jsx)("span", { className: MenuTrigger_module_css_1.default.bun })] })) }));
}
exports.MenuTrigger = MenuTrigger;
//# sourceMappingURL=MenuTrigger.js.map